"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = exports.InternalTag = void 0;
var InternalTag;
(function (InternalTag) {
    InternalTag["earliest"] = "earliest";
    InternalTag["finalized"] = "finalized";
    InternalTag["latest"] = "latest";
    InternalTag["safe"] = "safe";
    InternalTag["pending"] = "pending";
})(InternalTag || (exports.InternalTag = InternalTag = {}));
var Tag;
(function (Tag) {
    Tag.earliest = "earliest";
    Tag.finalized = "finalized";
    Tag.latest = "latest";
    Tag.safe = "safe";
    Tag.pending = "pending";
})(Tag || (exports.Tag = Tag = {}));
//# sourceMappingURL=tags.js.map